import React from 'react';
import {
    Container,
    Content,
    Collapse,
    CollapseButton,
    CollapseButtonText,
    CollapseIconWrapper,
} from './styles';
import collapseIcon from '../../assets/colapse-icon.svg';

function AccordionMenu({
    isOpen, toggle, icon, title, children, tour = '',
}) {
    return (
        <Container data-tour={tour}>
            <CollapseButton
                onClick={() => toggle()}
                className={`${isOpen ? 'isOpen' : undefined}`}
            >
                <CollapseButtonText>
                    {icon && icon} {title && title}
                </CollapseButtonText>
                <CollapseIconWrapper
                    style={{
                        marginLeft: 16,
                        transform: isOpen
                            ? 'rotateZ(0)'
                            : 'rotateZ(180deg)',
                    }}
                >
                    <img src={collapseIcon} alt="colapse" />
                </CollapseIconWrapper>
            </CollapseButton>
            <Collapse isOpen={isOpen}>
                <Content>{children}</Content>
            </Collapse>
        </Container>
    );
}

export default AccordionMenu;
